<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="fulfillments"
          :search="search"
          sort-by="created_at"
          sort-desc
          :items-per-page="25"
          :footer-props="{
            itemsPerPageOptions: [-1, 50, 25, 10],
          }"
          @click:row="navigateToFulfillment"
        >
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Übergaben</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <a class="v-btn v-btn--flat v-btn--text theme--light v-size--small primary--text" :href="route('contracts.fulfillments.proficiency', {'contract': contract.id})" target="_blank">
                aktuellen Leistungsnachweis anzeigen
              </a>
              <v-spacer />
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="createFulfillment"
              >
                Übergabe hinzufügen
              </v-btn>
            </v-toolbar>
          </template>
          <template #[`item.start_date`]="{ item }">
            <span>{{ getDateString(item.start_date) }}</span>
          </template>
          <template #[`item.actions`]="{ item }">
            <inertia-link :href="route('contracts.fulfillments.show', [contract, item.id])">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    class="mr-3"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>öffnen</span>
              </v-tooltip>
            </inertia-link>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Verträge',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      fulfillments: {
         type: Array,
         required: true,
      },
      contract: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         dialog: false,
         statuswahlOffer: null,
         search: '',
         headers: [
            { text: 'Startdatum', value: 'start_date' },
            { text: 'Positionen', value: 'positionsString' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],

      }
   },

   methods: {
      getDateString (dateVal) {
         return formattedDateString(dateVal)
      },
      createFulfillment () {
         this.$inertia.visit(this.route('contracts.fulfillments.create', this.contract))
      },
      navigateToFulfillment (_fulfillment) {
         this.$inertia.visit(this.route('contracts.fulfillments.show', [this.contract, _fulfillment]))
      },
   },
}
</script>
